function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.414 8l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 111.414 1.414L6.414 8z"
});

function SvgChevronBigLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjQxNDIxIDhMMTEuNzA3MSAxMy4yOTI5QzEyLjA5NzYgMTMuNjgzNCAxMi4wOTc2IDE0LjMxNjYgMTEuNzA3MSAxNC43MDcxQzExLjMxNjYgMTUuMDk3NiAxMC42ODM0IDE1LjA5NzYgMTAuMjkyOSAxNC43MDcxTDQuMjkyODkgOC43MDcxMUMzLjkwMjM3IDguMzE2NTggMy45MDIzNyA3LjY4MzQyIDQuMjkyODkgNy4yOTI4OUwxMC4yOTI5IDEuMjkyODlDMTAuNjgzNCAwLjkwMjM2OSAxMS4zMTY2IDAuOTAyMzY5IDExLjcwNzEgMS4yOTI4OUMxMi4wOTc2IDEuNjgzNDIgMTIuMDk3NiAyLjMxNjU4IDExLjcwNzEgMi43MDcxMUw2LjQxNDIxIDhaIiAvPgo8L3N2Zz4K";
export { SvgChevronBigLeft16 as ReactComponent };